var Language;
(function (Language) {
    Language["English"] = "en";
    Language["French"] = "fr";
    Language["Any"] = "en:fr";
})(Language || (Language = {}));
export default Language;
